import React from 'react';
import PropTypes from 'prop-types';

const RsvpPageHeader = ({
  page,
  rsvpAccessForm,
  guestRequestSubmitted,
  onHideAccessForm,
  wedding,
}) => {
  const headerClassName = `cms-page-header${
    (!page.description && !page.header_image_url) || !page.title ? ' flex-container' : ''
  }`;
  const descClassName = `page-description${page.header_image_url ? ' has-image-above' : ''}`;

  return (
    <div className={headerClassName}>
      <div className={rsvpAccessForm ? '' : 'cms-header-accent-top-left'} />
      <div className="cms-header-accent-top-right" />
      <div className="cms-header-accent-bottom-left" />
      <div className="cms-header-accent-bottom-right" />
      {/* default state - rsvp page title, whatever it is. */}
      <div>
        {!rsvpAccessForm && !guestRequestSubmitted && (
          <h1 className="for-small-laptops">{page.title}</h1>
        )}
        {/* request form state */}
        {rsvpAccessForm && !guestRequestSubmitted && (
          <div>
            <div className="back-btn text-left" onClick={() => onHideAccessForm()}>
              ‹ Back to RSVP
            </div>
            <h1>RSVP Request</h1>
          </div>
        )}
        {guestRequestSubmitted && rsvpAccessForm && <h1>Your Request Has Been Sent</h1>}
        {window.zola.env !== 'production' ? (
          <span>
            {page.header_image_url && (
              <img
                src={`${page.header_image_url}?h=400`}
                alt={`The Wedding Website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`}
                className="img-responsive center-block"
              />
            )}
          </span>
        ) : (
          <span>
            {page.header_image_url && (
              <img
                src={`${page.header_image_url}?h=400`}
                alt={page.title}
                className="img-responsive center-block"
              />
            )}
          </span>
        )}
        {page.description && !guestRequestSubmitted && !rsvpAccessForm && (
          <p className={descClassName}>{page.description}</p>
        )}
      </div>
    </div>
  );
};

RsvpPageHeader.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string,
    header_image_url: PropTypes.string,
    description: PropTypes.string,
  }),
  rsvpAccessForm: PropTypes.bool,
  guestRequestSubmitted: PropTypes.bool,
  onHideAccessForm: PropTypes.func,
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string,
    owner_last_name: PropTypes.string,
    partner_first_name: PropTypes.string,
    partner_last_name: PropTypes.string,
  }),
};

export default RsvpPageHeader;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpPageHeader.jsx